import axios from "axios";
import auth0 from "auth0-js";
import jwt_decode from "jwt-decode";
import store from "@/store";
import { clearStoredSession } from "@/Shared/session";
import { getLogoutReturnUrl } from "@/Shared/authUrls";

type DecodedToken = {
  email?: string;
};

type LogoutOptions = {
  audit?: boolean;
};

const webAuth = new auth0.WebAuth({
  domain: process.env.VUE_APP_Auth_Domain,
  clientID: process.env.VUE_APP_Auth_Client_id,
});

export async function logoutaudit(): Promise<void> {
  const token = store.getters.getIdToken;

  if (!token) {
    return;
  }

  try {
    const decoded = jwt_decode<DecodedToken>(token);
    const emailId = decoded?.email;

    if (!emailId) {
      return;
    }

    const now = new Date().toISOString();

    await axios.post(
      `${process.env.VUE_APP_Service_URL}/account-core/user/saveloginaudit`,
      {
        userEmail: emailId,
        logdetails: [
          {
            action: "Log Out",
            date: now,
            time: now,
          },
        ],
      },
      {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.log("Logout audit failed", error);
  }
}

export async function performLogout(options: LogoutOptions = {}): Promise<void> {
  const { audit = true } = options;

  if (audit) {
    await logoutaudit();
  }

  clearStoredSession();
  webAuth.logout({
    returnTo: getLogoutReturnUrl(),
    clientID: process.env.VUE_APP_Auth_Client_id,
  });
}
